/** List of supported currency codes. */
export const currencies = [
  'EUR',
  'USD',
  'GBP',
  'PLN',
  'CHF',
  'SEK',
  'DKK',
  'NOK',
  'ETH',
  'BTC',
  'BCH',
  'LTC',
  'DASH',
  'CUD',
  'USC',
] as const
